/* ==========================================================================
   Zimply Natural — Exit Intent Trigger
   Triggers a Shopify newsletter-popup section when user shows exit intent.
   - Desktop: mouse leaves viewport via top edge
   - Mobile: rapid scroll-up in upper third + brief idle
   - 30-day cookie suppresses re-trigger
   ========================================================================== */

(function () {
  'use strict';

  var COOKIE_NAME = 'zimply_exit_intent_shown';
  var COOKIE_DAYS = 30;
  var POPUP_SELECTOR = 'newsletter-modal, .newsletter-modal, [data-section-type="newsletter-popup"]';
  var MIN_SESSION_MS = 8000; // don't fire within first 8s

  function hasCookie(name) {
    return document.cookie.split('; ').some(function (c) {
      return c.indexOf(name + '=') === 0;
    });
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function findPopup() {
    var el = document.querySelector(POPUP_SELECTOR);
    return el || null;
  }

  function triggerPopup() {
    if (hasCookie(COOKIE_NAME)) return;
    var popup = findPopup();
    if (!popup) return;

    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);

    if (typeof popup.show === 'function') {
      popup.show();
    } else if (popup.dispatchEvent) {
      popup.dispatchEvent(new CustomEvent('zimply:open', { bubbles: true }));
      popup.removeAttribute('hidden');
      popup.classList.add('is-open', 'is-visible');
    }
  }

  function init() {
    if (window.Shopify && Shopify.designMode) return;
    if (hasCookie(COOKIE_NAME)) return;
    var sessionStart = Date.now();

    function ready() {
      return Date.now() - sessionStart > MIN_SESSION_MS;
    }

    // Desktop: mouseleave from top edge
    document.documentElement.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0 && ready()) triggerPopup();
    });

    // Mobile: rapid scroll-up heuristic
    var lastScroll = window.pageYOffset;
    var lastScrollTs = Date.now();
    var fastScrollUpDetected = false;

    window.addEventListener(
      'scroll',
      function () {
        var now = Date.now();
        var current = window.pageYOffset;
        var delta = lastScroll - current;
        var dt = now - lastScrollTs;
        // fast scroll-up: > 200px in <300ms while in upper 30% of page
        if (
          delta > 200 &&
          dt < 300 &&
          current < window.innerHeight * 0.5 &&
          ready()
        ) {
          fastScrollUpDetected = true;
          setTimeout(function () {
            if (fastScrollUpDetected) triggerPopup();
          }, 600);
        }
        lastScroll = current;
        lastScrollTs = now;
      },
      { passive: true }
    );

    // Tab visibility change → user about to leave
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden' && ready()) {
        // don't trigger on tab hide alone — too aggressive
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
